import { MapTo } from '@adobe/aem-react-editable-components';
import FaqMenu, { FaqMenuEditConfig } from './FaqMenu';

export default MapTo('cob-corp-acquisition/components/creditonebank/faq-menu')(FaqMenu, FaqMenuEditConfig);